"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var review_star_bg_png_1 = __importDefault(require("images/review_star_bg.png"));
var review_star_light_png_1 = __importDefault(require("images/review_star_light.png"));
var REVIEW_MAX = 5;
var RateStart = function (props) {
    var _a = (0, react_1.useState)(0), rating = _a[0], setRating = _a[1];
    var _b = (0, react_1.useState)(false), leaveAfterClick = _b[0], setLeaveAfterClick = _b[1];
    var handleClickStart = function (rate) {
        props.onClick(rate);
        setLeaveAfterClick(true);
    };
    var handleLeave = function () {
        if (!leaveAfterClick) {
            setRating(props.rate);
        }
        setLeaveAfterClick(false);
    };
    return (react_1.default.createElement("div", { className: "formsCommon-RateStart_Wrapper" }, __spreadArray([], Array(REVIEW_MAX), true).map(function (_, index) { return (react_1.default.createElement("div", { key: index, className: "review_star", onMouseEnter: function () { return setRating(index + 1); }, onMouseLeave: handleLeave, onClick: function () { return handleClickStart(index + 1); } },
        react_1.default.createElement("img", { src: index < rating ? review_star_light_png_1.default : review_star_bg_png_1.default, alt: index < rating ? "★" : "☆", className: "lazyload" }))); })));
};
exports.default = RateStart;
